import { Pipe, PipeTransform } from '@angular/core';



const resultLookup = {
  1: 'red',      //'BLOCKED',
  2: 'green',      //'ANSWERED',
  3: 'red',      //"MISSED",
  4: 'red',      //"USER_NOT_FOUND",
  5: 'red',      //"DECLINED",
  6: 'red',      //"BUSY",
  7: 'red',      //"CANCELLED",
  8: 'red',      //"SIP_FAILURE",
  9: 'red',      //"ISDN_FAILURE",
  10: 'red',      //"OTHER_FAILURE",
  11: 'red',     //"INCOMPLETE",
  12: '#ff8c00',     //"QUEUED", 
  13: 'green',     //"ANSWERED_BY_OTHER",
  14: '#ff8c00',     //"DIVERTED",
  15: 'red',     //"CLOSED",
  16: '#ff8c00'     //"CALLBACK_REQUESTED"
};



@Pipe({
  name: 'telepoCdrResultColorPipe'
})
export class TelepoCdrResultColorPipe implements PipeTransform {
  transform(value: string): any {
    
    return resultLookup[value];
  }
}
